import { useEffect } from "react"

import { useAppState } from "../../context/appStateContext"
import { useBlackFriday } from "../../context/blackFridayContext"
import { PurchasProvider } from "../../context/purchaseContext"
import { UltimateAlertsProvider } from "../../context/ultimateAlertsContext"
import PromoPremiumToUltimatePaywall from "./PromoPremiumToUltimatePaywall/PromoPremiumToUltimatePaywall"
import PromoRegularPaywall from "./PromoRegularPaywall/PromoRegularPaywall"

const PromoPaywall = () => {
  const { actions } = useAppState()
  const state = useBlackFriday().state
  const premiumUser = state.isPremiumUser || state.isUltimateLaunch

  useEffect(() => {
    const color = "#1d212b"

    if (!premiumUser) {
      actions.setFooterInsetColor(color)
      actions.setHeaderInsetColor(color)
    } else {
      actions.setFooterInsetColor("#000")
    }
  }, [])

  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        {!premiumUser && <PromoRegularPaywall />}
        {premiumUser && <PromoPremiumToUltimatePaywall />}
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

export default PromoPaywall
